import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type CompanyCreateRequest = {
  company: {
    name: string;
    name_kana: string;
    postal_code: string;
    prefecture_code: number;
    address: string;
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    establishment_year: string;
    fiscal_month: string;
    industry: string;
    service_description: string;
    revenus_scale: string;
    employee_scale: string;
  };
  company_user: {
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    email: string;
    bizsol_sub?: string;
  };
  checkbox: boolean;
};

export type CompanyCreateResponse = {
  requires_user_approval: boolean;
};

export type CompanyUserCreateErrorResponse = {
  company: {
    name: string[];
    name_kana: string[];
    postal_code: string[];
    prefecture_code: string[];
    address: string[];
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    establishment_year: string[];
    fiscal_month: string[];
    industry: string[];
    service_description: string[];
    revenus_scale: string[];
    employee_scale: string[];
    birthday: string[];
  };
  company_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    email: string[];
    birthday: string[];
  };
  checkbox: string[];
};

export const companyUserRegisterApiClient = {
  register: async (
    data: CompanyCreateRequest,
  ): Promise<ApiResult<CompanyCreateResponse, CompanyUserCreateErrorResponse>> => {
    return await axiosClient.post('/company/company-users/register', data);
  },
};
